import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f9d88c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "process-btn__title" }, "Оформить заказ ", -1))
const _hoisted_2 = { class: "process-btn__sum rouble-symbol" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrderWarning = _resolveComponent("OrderWarning")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["order-layout", {
      'order-layout--empty': _ctx.orderStore.isEmpty,
    }])
  }, [
    _createVNode(_component_OrderWarning, {
      class: "delivery-warning",
      "work-schedule": _ctx.companyStore.activeCompany?.workSchedule,
      "price-for-delivery": _ctx.orderStore.priceForDelivery,
      "is-delayed-order": !!_ctx.orderStore.cookingTime
    }, null, 8, ["work-schedule", "price-for-delivery", "is-delayed-order"]),
    _createElementVNode("button", {
      class: "process-btn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToCart && _ctx.goToCart(...args)))
    }, [
      _hoisted_1,
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.orderStore.isEmpty ? '0' : _ctx.$filters.formattedNumber(_ctx.orderStore.activeOrder?.totalPrice)), 1)
    ])
  ], 2))
}